import React, { useEffect, useLayoutEffect, useState } from 'react';
import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';

import { setBranches, setBrands, setConstants, setHero, setHomeProducts, setImages, setProducts, setSelected, setVision } from "./store/reducers/CartReducer";
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Loader from './Loading';
import { ProductsPage } from './components/ProductsPage';
import { Header } from './components/Header';
import { BrandsPage } from './components/BrandsPage';
import { Toaster } from 'react-hot-toast';
import { ProductPage } from './components/ProductPage';
import { BrandsProductsPage } from './components/BrandProductsPage';

import About from './components/About';



import Contact from './components/Contact';
import Test from './components/Test';
import { Home } from './components/Home';


 


const App = () => {

    const location = useLocation();

  
 

    useEffect(() => {

     window.scrollTo({ top: 0, left: 0, behavior: 'instant' })

    
     }, [location.pathname]);


      const [loading, setLoading] = useState(false);

      const lang = useSelector((state) => state.cart.lang);
      const theme = useSelector((state) => state.cart.theme);
      const dispatch = useDispatch()
    
      useEffect(() => {
        setLoading(true);

        if(localStorage.getItem('lang')===null){
          localStorage.setItem('lang','ar')
        }
    
        try {
     
       
       
        //  axios.get(`${window.location.origin}/alhubaishi/Api/data.php`)
        axios.get(`https://dev.dawasmart.com/Api/data.php`)
         .then(res => {
       setLoading(false);
    
      
        dispatch(setConstants(res.data.productlist.constants));
        dispatch(setBrands(res.data.productlist.productdata));
        dispatch(setHero(res.data.productlist.herodata));
        dispatch(setVision(res.data.productlist.vision));
        dispatch(setBranches(res.data.productlist.region));
        dispatch(setImages(res.data.productlist.images));
        dispatch(setProducts(res.data.productlist.categoriesProducts));
        dispatch(setHomeProducts(res.data.productlist.homeproducts));
          
          })
       } catch (error) {
       
    setLoading(false);
         console.error(error);
       }    
    
     }, []);
    
    
    
    
    
    
    
    
    



return (
      loading ? <Loader theme={theme} />

      :
     
             <div dir={lang === 'en' ? 'ltr' : 'rtl'} style={{fontFamily:'CairoRegular'}} className="App ">
            <Toaster  /> 
          <main className={`flex overflow-hidden flex-col ${theme === 'LM' ? 'bg-[#f8fbfe] text-[#333333]' : 'bg-[#090b0e] text-white  '  }  w-full`}>
       
       <Routes>
   
       <Route path="" element={<Header />} >

       <Route path="" element={<Home   />} />
       <Route path="Products" element={<ProductsPage  />} />
       <Route path="Pharmacies" element={<BrandsPage  />} />
       <Route path="Product/:id" element={<ProductPage  />} />
       <Route path="Brand/:id" element={<BrandsProductsPage  />} />

       </Route>

         </Routes>
      </main> 
     
         </div> 
    
);
};

export default App;
